<script>
export default {
    methods: {},
    props: ["status"],
    translate25Context: 'troubleshooting',
    mounted() {
    }
};
</script>

<template>
    <div class="troubleshooting-status" :class="[status]">
        <f-icon class="ok" icon="fa6-check"></f-icon>
        <f-icon class="ko" icon="fa6-xmark"></f-icon>
        <f-icon class="warning" icon="fa6-triangle-exclamation"></f-icon>
        <f-icon class="unknown" icon="fa6-question"></f-icon>
        <f-icon class="pending" spin icon="fa6-spinner"></f-icon>
        <slot name="content"></slot>
    </div>
</template>

<style lang="scss">
.troubleshooting-status {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    font-weight: 400;
    color: var(--black);

    .ok {
        color: var(--primary);
        display: none;
    }

    .ko {
        color: var(--statusNegative);
        display: none;
    }

    .warning {
        color: var(--statusNotice);
        display: none;
    }

    .unknown {
        color: var(--statusNotice);
        display: none;
    }


    .pending {
        color: var(--black);
        display: none;
    }

    &.ok .ok,
    &.ko .ko,
    &.warning .warning,
    &.unknown .unknown,
    &.pending .pending {
        display: block;
    }
}
</style>